import {
  SlickEvent,
  SlickEventHandler,
  type SlickGrid,
  type SlickPlugin,
} from 'slickgrid';
import * as _ from 'lodash';
// @ts-ignore
import { RemoteData } from './remoteData';

export interface RemoteDataOptions {
  url: string;
  params?: any;
}

export class RemoteDataWrapper implements SlickPlugin {
  pluginName = 'RemoteDataWrapper' as const;

  private _legacyImpl: any;
  private _grid: SlickGrid<any> | null = null;
  private _handler = new SlickEventHandler();

  onDataLoading = new SlickEvent();
  onDataLoaded = new SlickEvent();
  onDataLoadFailed = new SlickEvent();
  onRowCountChanged = new SlickEvent();
  onRowsChanged = new SlickEvent();

  constructor(private options: RemoteDataOptions) {
    this._legacyImpl = RemoteData({
      url: options.url,
      adapter: {
        dataLoaded: (req: any, res: any) => {
          const items = res.data || res.items || [];
          const total = parseInt(
            res.total_count || res.total || items.length,
            10,
          );

          this.onRowCountChanged.notify({ total, visible: total });
          this.onDataLoaded.notify({ items, total });

          return {
            items: items,
            from: req.start,
            to: req.start + items.length,
            count: items.length,
            total: total,
          };
        },
      },
      query: options.params || {},
    });
  }

  get data() {
    return this._legacyImpl.data;
  }

  init(grid: SlickGrid<any>) {
    this._grid = grid;
    this._legacyImpl.init(grid);
  }

  destroy() {
    this._legacyImpl.destroy();
    this._handler.unsubscribeAll();
  }

  ensureData(force?: boolean) {
    this.onDataLoading.notify({});
    const req = this._legacyImpl.ensureData(force);

    if (req && typeof req.then === 'function') {
      req.then(null, (err: any) => {
        if (err.statusText !== 'abort') {
          this.onDataLoadFailed.notify({ error: err });
        }
      });
    }
  }

  reload() {
    this._legacyImpl.clear();
    this.ensureData(true);
  }

  setSort(field: string, dir: number) {}

  setFilter(filterArgs: any) {
    this._legacyImpl.setQuery(filterArgs);
    this.reload();
  }

  getItems() {
    const data = this._legacyImpl.data;
    const items: any[] = [];

    for (const key in data) {
      if (
        key !== 'length' &&
        Object.prototype.hasOwnProperty.call(data, key) &&
        data[key]
      ) {
        items.push(data[key]);
      }
    }
    return items;
  }

  groupBy(grouping: any) {
    console.warn('Remote grouping is handled by server or not supported yet.');
  }
}
